import React, { useState } from 'react'
import { Checkbox } from "antd"

import Modal from "../resusable/modal"
import NewInventoryItem from './newinventoryitem'

import { useListData, usePet, useToggle } from '../../modules'
import pluralize from 'pluralize'
import Creatable from 'react-select/creatable'

const RestockOpen = ({ toggle, visible, store, onPerform }) => {
    const [bulk, setBulk] = useState()
    const [item, setItem] = useState()
    const [contains, setContains] = useState()
    const [string, setString] = useState('')
    const [singles, setSingles] = useState()

    const [
        { loading: invLoading, fetch: fetchInvItems },
        { list: items = [] }
    ] = useListData('inventoryItems', { string }, { notify: true }, 'items')

    const search = str => {
        if (str?.trim()?.length > 2) {
            setString(str)
            fetchInvItems()
        }
    }

    const [newItem, toggleNewItem] = useToggle()

    const toggleSingles = () => setSingles(!singles)

    const modify = e => {
        switch (e.target.name) {
            case 'bulk':
                setBulk(e.target.value)
                break

            case 'contains':
                setContains(e.target.value)
                break

            default:
                break
        }
    }

    const onComplete = ({ }, notif, ops) => {
        onPerform()
        notif('Item has been restocked', ops('success'))

        setTimeout(toggle, 300)
    }

    const [{ loading }, execute] = usePet('directlyReceiveItems', {
        items: [
            {
                item: item?._id,
                store: store?.value,
                bulkCount: bulk,
                containing: contains
            }
        ],
        committed: true
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Restocking item...' } })

    return (
        <Modal
            h="h-auto"
            w="w-1/4"
            title="Add Item"
            toggle={toggle}
            visible={visible}>
            {
                newItem &&
                <NewInventoryItem
                    string={ string }
                    store={store}
                    onPerform={setItem}
                    toggle={toggleNewItem}
                    visible={newItem} />
            }
            <div className="w-full mb-3">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                    Inventory Item
                </label>
                <Creatable
                    onCreateOption={toggleNewItem}
                    isLoading={invLoading}
                    loadingMessage={str => `Searching for "${str?.inputValue}"`}
                    onInputChange={search}
                    value={item}
                    onChange={ op => {
                        setItem(op)
                        setSingles(op?.receivedIn === op?.issuedIn)

                        if (op?.receivedIn === op?.issuedIn)
                            setBulk(1)
                    }}
                    options={items.map(itm => ({ label: itm.name, value: itm, ...itm }))}
                    placeholder="Search for inventory item" />
            </div>
            {
                item &&
                <>
                    <Checkbox checked={singles} onChange={() => {
                        setBulk(1)
                        toggleSingles()
                    }}>Items arrived in {item?.issuedIn?.toLowerCase()}</Checkbox>
                    {
                        !singles &&
                        <div className="flex flex-wrap mt-3">
                            <div className="w-full px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                    How many {item?.receivedIn}?
                                </label>
                                <input
                                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                    id="grid-bulk"
                                    name="bulk"
                                    value={bulk}
                                    onChange={modify}
                                    type="number"
                                    placeholder="50" />
                            </div>
                        </div>
                    }
                    <div className="flex flex-wrap mt-3 mb-6">
                        <div className="w-full px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                How many {item?.issuedIn}?
                            </label>
                            <input
                                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                id="grid-contains"
                                type="number"
                                name="contains"
                                value={contains}
                                onChange={modify}
                                placeholder="100" />
                            <p className="text-gray-500 text-xs italic">How many {item?.issuedIn?.toLowerCase()} {singles ? 'were received' : `does each ${item?.receivedIn && pluralize.singular(item?.receivedIn?.toLowerCase())} contain`}?</p>
                        </div>
                    </div>
                </>
            }
            <div className="flex justify-end">
                <button disabled={loading} onClick={execute} className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Add {(bulk * contains) ? (bulk * contains) : 0} {item?.issuedIn}</button>
            </div>
        </Modal>
    )
}

export default RestockOpen